var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title:
          "" +
          _vm.$t("storage::out-stock::add_export") +
          (_vm.type === "in"
            ? _vm.$t("storage::out-stock::add_in_bill")
            : _vm.$t("storage::out-stock::bill")),
        visible: _vm.visible,
        "close-on-click-modal": false,
        width: "600px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: function ($event) {
          _vm.tempList = []
        },
      },
    },
    [
      !_vm.skuList.length
        ? _c(
            "el-upload",
            {
              ref: "upload",
              staticStyle: { "margin-left": "10px", "text-align": "center" },
              attrs: {
                action: _vm.uploadUrl,
                accept: ".xls,.cvs,.xlsx",
                "http-request": _vm.UploadImage,
                "show-file-list": false,
                drag: "",
              },
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("storage::out-stock::add_upload_drag")) +
                    " "
                ),
                _c("em", [
                  _vm._v(
                    _vm._s(_vm.$t("storage::out-stock::add_upload_click"))
                  ),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("storage::out-stock::add_upload_template")
                      ) +
                      " "
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: { click: _vm.getImportTemplate },
                    },
                    [_vm._v(_vm._s(_vm.$t("storage::out-stock::add_download")))]
                  ),
                ],
                1
              ),
            ]
          )
        : _c("z-table", {
            staticClass: "prodinfo--table",
            attrs: {
              columns: _vm.columns,
              data: _vm.skuList,
              "max-height": 400,
              pagination: false,
            },
            scopedSlots: _vm._u([
              {
                key: "skuId",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(row.skuId) +
                          _vm._s(row.skuProperty ? "-" + row.skuProperty : "")
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "spuName",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { staticClass: "prodinfo--table__imgTd" },
                      [
                        _c(
                          "el-popover",
                          {
                            attrs: { placement: "top-start", trigger: "hover" },
                          },
                          [
                            _c("img", {
                              staticStyle: { width: "250px", height: "250px" },
                              attrs: { src: row.img },
                            }),
                            _c("img", {
                              attrs: { slot: "reference", src: row.img },
                              slot: "reference",
                            }),
                          ]
                        ),
                        _c("div", [
                          _c("div", [_vm._v(_vm._s(row.title))]),
                          _c("div", [_vm._v(_vm._s(row.categoryName))]),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("storage::out-stock::add_cancel")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.addSku } },
            [_vm._v(_vm._s(_vm.$t("storage::out-stock::add_add")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }